import { IncomingMessage } from 'http';

import { fechFromBPartsApi, CustomError } from '../utils';

export const fetchLoggedUser = async (
  {
    locale,
  }: {
    locale: string;
  },
  req?: IncomingMessage
): Promise<TLoggedUser | null> => {
  const auth = await fechFromBPartsApi<Response>(`/${locale}/shop/accounts/logged-user`, {
    method: 'GET',
    credentials: 'include',
    headers: req ? new Headers(req.headers as HeadersInit) : undefined,
  });

  if (auth.status === 403 && process.env.NEXT_PUBLIC_TENANT === '5') {
    throw new CustomError({ status: 403, data: { detail: 'Forbidden' } });
  }

  if (auth.ok) return auth.json();
  else return null;
};

export default fetchLoggedUser;
